import React, { useState, useEffect } from "react";
import { useResolvedPath, useNavigate } from "react-router-dom";
import "./Navbar.scss";
import linkConfigurations from "./linkConfigurations";
import { Link } from "react-router-dom";

import arrow from "../../Assets/Navbar/arrow-left.svg";

function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [buttonText, setButtonText] = useState("Dropdown");
  const navigate = useNavigate();
  const resolvedPath = useResolvedPath();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const [wider, setWider] = useState(false);

  const checkWidth = () => {
    if (
      resolvedPath.pathname === "/hari-pelaksanaan" ||
      resolvedPath.pathname === "/divisi" ||
      resolvedPath.pathname === "/after-movie"
    ) {
      if (window.innerWidth > 1200) {
        setWider(true);
      } else {
        setWider(false);
      }
    } else {
      setWider(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      checkWidth();
    };

    checkWidth();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [resolvedPath.pathname]);


  useEffect(() => {
    const path = resolvedPath.pathname;
    const dropdownItems = [
      { path: "/hari-pelaksanaan", text: "Hari Pelaksanaan" },
      { path: "/dibalik-kepanitiaan", text: "Di Balik Kepanitiaan" },
      { path: "/divisi", text: "Foto Divisi" },
      { path: "/sayembara-visual", text: "Sayembara Visual" },
      {
        path: "/after-movie",
        text: <em style={{ fontStyle: "italic" }}>After Movie</em>,
      },
    ];

    const matchingItem = dropdownItems.find((item) =>
      path.startsWith(item.path)
    );
    if (matchingItem) {
      setButtonText(matchingItem.text);
    } else {
      setButtonText("Dropdown");
    }
  }, [resolvedPath.pathname]);

  if (resolvedPath.pathname === "/") {
    return null;
  }

  const handleBackToDivisi = () => {
    navigate("/divisi");
  };

  const handleBackToHariPelaksanaan = () => {
    navigate("/hari-pelaksanaan");
  };

  return (
    <div className="navigation">
      <div className={`desktop ${wider ? "wider" : ""}`}>
        {resolvedPath.pathname.startsWith("/divisi-") && (
          <button className="back-btn" onClick={handleBackToDivisi}>
            <img src={arrow} alt="" />
            <p>Kembali</p>
          </button>
        )}
        {resolvedPath.pathname.startsWith("/hari-pelaksanaan/") && (
          <button className="back-btn" onClick={handleBackToHariPelaksanaan}>
            <img src={arrow} alt="" />
            <p>Kembali</p>
          </button>
        )}
        <div className="nav-block">
          <div
            className={`nav-link ${resolvedPath.pathname.startsWith("/hari-pelaksanaan")
              ? "active"
              : ""
              }`}>
            <Link to="/hari-pelaksanaan">Hari Pelaksanaan</Link>
          </div>
          <div
            className={`nav-link ${resolvedPath.pathname === "/dibalik-kepanitiaan" ? "active" : ""
              }`}>
            <Link to="/dibalik-kepanitiaan">Di Balik Kepanitiaan</Link>
          </div>
          {linkConfigurations.map((config) => {
            if (resolvedPath.pathname === config.path) {
              return config.element;
            }
            return null;
          })}
          <div
            className={`nav-link ${resolvedPath.pathname === "/sayembara-visual" ? "active" : ""
              }`}>
            <Link to="/sayembara-visual">Sayembara Visual</Link>
          </div>
          <div
            className={`nav-link ${resolvedPath.pathname === "/after-movie" ? "active" : ""
              }`}>
            <Link to="/after-movie">
              <i>After Movie</i>
            </Link>
          </div>
        </div>
      </div>
      <div className="navbar">
        <div className="dropdown">
          {resolvedPath.pathname.startsWith("/divisi-") && (
            <button className="back-btn" onClick={handleBackToDivisi}>
              <img src={arrow} alt="" />
            </button>
          )}
          {resolvedPath.pathname.startsWith("/hari-pelaksanaan/") && (
            <button className="back-btn" onClick={handleBackToHariPelaksanaan}>
              <img src={arrow} alt="" />
            </button>
          )}
          {linkConfigurations.map((config) => {
            if (resolvedPath.pathname === config.path) {
              return (
                <button
                  style={config.style}
                  className="dropbtn"
                  onClick={() => {
                    toggleDropdown();
                  }}>
                  {buttonText}
                  <input
                    type="checkbox"
                    id="checkbox"
                    checked={isDropdownOpen}
                    onChange={() => { }}
                  />
                  <label className={`toggle ${isDropdownOpen ? "active" : ""}`}>
                    <div className="bar bar--top"></div>
                    <div className="bar bar--middle"></div>
                    <div className="bar bar--bottom"></div>
                  </label>
                </button>
              );
            }
            return null;
          })}
          <div
            className="dropdown-content"
            style={{ display: isDropdownOpen ? "flex" : "none" }}>
            <Link
              to="/hari-pelaksanaan"
              className={`dropdown-link ${resolvedPath.pathname.startsWith("/hari-pelaksanaan")
                ? "active"
                : ""
                }`}>
              {resolvedPath.pathname.startsWith("/hari-pelaksanaan") && (
                <span className="default-bullet"></span>
              )}
              <span>Hari Pelaksanaan</span>
            </Link>
            <Link
              className={`dropdown-link ${resolvedPath.pathname === "/dibalik-kepanitiaan" ? "active" : ""
                }`}
              to="/dibalik-kepanitiaan">
              {resolvedPath.pathname === "/dibalik-kepanitiaan" && (
                <div className="default-bullet"></div>
              )}
              <span>Di Balik Kepanitiaan</span>
            </Link>
            <Link
              className={`dropdown-link ${resolvedPath.pathname.startsWith("/divisi") ? "active" : ""
                }`}
              to="/divisi">
              {resolvedPath.pathname.startsWith("/divisi") && (
                <>
                  {linkConfigurations.map((config) => {
                    if (resolvedPath.pathname === config.path) {
                      return config.bullet;
                    }
                    return null;
                  })}
                </>
              )}
              <span>Foto Divisi</span>
            </Link>
            <Link
              className={`dropdown-link ${resolvedPath.pathname === "/sayembara-visual" ? "active" : ""
                }`}
              to="/sayembara-visual">
              {resolvedPath.pathname === "/sayembara-visual" && (
                <div className="default-bullet"></div>
              )}
              <span>Sayembara Visual</span>
            </Link>
            <Link
              className={`dropdown-link ${resolvedPath.pathname === "/after-movie" ? "active" : ""
                }`}
              to="/after-movie">
              {resolvedPath.pathname.startsWith("/after-movie") && (
                <div className="default-bullet"></div>
              )}
              <span>
                <i>After Movie</i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
